import React, {ChangeEvent} from 'react';
import Input from "patient-ping-remedy/packages/input";

type Props = {
  id?: string;
  type?: string;
  required?: "" | "required" | "optional" | undefined;
  className?: string;
  labelText?: string;
  value?: string | number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  validate: (val: string) => string;
  placeholder?: string;
  disabled?: boolean;
}

const ValidatedInput = (props: Props) => {
  const errorMessage = props.validate(String(props.value ?? ''));

  return (
    <Input
      id={props.id}
      data-testid={props.id}
      className={props.className}
      labelText={props.labelText}
      type={props.type}
      value={props.value}
      required={props.required}
      onChange={props.onChange}
      error={!!errorMessage}
      errorMessage={errorMessage}
      placeholder={props.placeholder}
      isDisabled={props.disabled}
    />
  );
};

export default ValidatedInput;
